/* =========================
   FacetFiltersForm（最终版）
========================= */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }

  static renderPage(searchParams) {
    const url = `${window.location.pathname}?section_id=${document.getElementById('product-grid').dataset.id}&${searchParams}`;

    // loading 开启
    document.querySelectorAll('.loading__spinner')
      .forEach(el => el.classList.remove('hidden'));

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        // 商品列表
        document.getElementById('ProductGridContainer').innerHTML =
          parsed.getElementById('ProductGridContainer').innerHTML;

        // 排序区域（会被替换）
        const sorting = parsed.querySelector('.sorting');
        if (sorting) {
          document.querySelector('.sorting').innerHTML = sorting.innerHTML;
        }

        // 🔥 重新初始化 select
        initCustomSelect();

        // loading 关闭
        document.querySelectorAll('.loading__spinner')
          .forEach(el => el.classList.add('hidden'));
      })
      .catch(() => {
        document.querySelectorAll('.loading__spinner')
          .forEach(el => el.classList.add('hidden'));
      });

    history.pushState({}, '', `?${searchParams}`);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    if (!form) return;

    const params = new URLSearchParams(new FormData(form));

    // 🔥 去重 sort_by
    const sort = params.get('sort_by');
    params.delete('sort_by');
    if (sort) params.set('sort_by', sort);

    FacetFiltersForm.renderPage(params.toString());
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);


/* =========================
   Custom Select（最终版）
========================= */
function initCustomSelect(scope = document) {
  const wrappers = scope.querySelectorAll('.custom-select');

  wrappers.forEach(wrapper => {
    if (wrapper.dataset.init === 'true') return;
    wrapper.dataset.init = 'true';

    const trigger = wrapper.querySelector('.custom-select__trigger');
    const text = wrapper.querySelector('.custom-select__text');
    const options = wrapper.querySelectorAll('.custom-option');
    const select = wrapper.querySelector('select[name="sort_by"]');

    if (!trigger || !select) return;

    /* =========================
       URL 同步
    ========================= */
    const urlParams = new URLSearchParams(window.location.search);
    const urlSort = urlParams.get('sort_by');
    if (urlSort) {
      select.value = urlSort;
    }

    /* =========================
       初始化选中项
    ========================= */
    const selectedValue = select.value;
    let activeOption = null;

    options.forEach(option => {
      if (option.dataset.value === selectedValue) {
        activeOption = option;
      }
    });

    if (!activeOption) {
      activeOption = wrapper.querySelector('[data-selected="true"]');
    }

    if (!activeOption && options.length) {
      activeOption = options[0];
    }

    if (activeOption) {
      text.innerText = activeOption.dataset.name || activeOption.innerText;

      options.forEach(o => {
        o.removeAttribute('data-selected');
        o.classList.remove('is-selected');
      });

      activeOption.setAttribute('data-selected', 'true');
      activeOption.classList.add('is-selected');
    }

    /* =========================
       点击 trigger（修复 toggle）
    ========================= */
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      const isOpen = wrapper.classList.contains('open');

      // 关闭其他
      document.querySelectorAll('.custom-select.open')
        .forEach(el => {
          if (el !== wrapper) el.classList.remove('open');
        });

      // 切换当前
      if (isOpen) {
        wrapper.classList.remove('open');
      } else {
        wrapper.classList.add('open');
      }
    });

    /* =========================
       选择 option
    ========================= */
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();

        const value = option.dataset.value;

        // UI
        text.innerText = option.dataset.name || option.innerText;

        // 清除状态
        options.forEach(o => {
          o.removeAttribute('data-selected');
          o.classList.remove('is-selected');
        });

        // 设置状态
        option.setAttribute('data-selected', 'true');
        option.classList.add('is-selected');

        wrapper.classList.remove('open');

        // 同步 select
        select.value = value;

        // 触发 Dawn
        select.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  });
}


/* =========================
   全局点击（只点外部才关闭）
========================= */
document.addEventListener('click', (e) => {
  document.querySelectorAll('.custom-select.open')
    .forEach(el => {
      if (!el.contains(e.target)) {
        el.classList.remove('open');
      }
    });
});


/* =========================
   初始化
========================= */
document.addEventListener('DOMContentLoaded', () => {
  initCustomSelect();

  // 🔥 防止多个 sort_by
  const sorts = document.querySelectorAll('[name="sort_by"]');
  sorts.forEach((el, i) => {
    if (i > 0) el.disabled = true;
  });
});


/* =========================
   Shopify section reload
========================= */
document.addEventListener('shopify:section:load', (e) => {
  initCustomSelect(e.target);
});